import { Link } from 'react-router-dom';
import { competitorHubs } from '@/mocks/categories';

export default function CompetitorHubsSection() {
  return (
    <section className="w-full py-16 md:py-24 px-4 md:px-8 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-heading font-bold text-foreground-950 mb-3">
            Spreadsheet Platform Hubs
          </h2>
          <p className="text-foreground-600 font-body text-base max-w-2xl mx-auto">
            Explore comprehensive guides and comparisons across all major spreadsheet research platforms
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {competitorHubs.map((hub) => (
            <Link
              key={hub.name}
              to={hub.slug}
              className="group bg-background-50 rounded-2xl p-6 border border-background-200 hover:border-primary-300 transition-all cursor-pointer"
            >
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950 mb-2 group-hover:text-primary-600 transition-colors">
                {hub.name}
              </h3>
              <p className="text-foreground-600 text-sm font-body leading-relaxed line-clamp-3">
                {hub.description}
              </p>
              <div className="mt-4 inline-flex items-center gap-1 text-xs font-medium text-primary-600 font-label">
                Explore Guide
                <span className="w-3 h-3 flex items-center justify-center">
                  <i className="ri-arrow-right-line text-xs"></i>
                </span>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}